import { render, staticRenderFns } from "./StylizationPartDetails.vue?vue&type=template&id=82fbe326&scoped=true"
import script from "./StylizationPartDetails.vue?vue&type=script&lang=ts"
export * from "./StylizationPartDetails.vue?vue&type=script&lang=ts"
import style0 from "./StylizationPartDetails.vue?vue&type=style&index=0&id=82fbe326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fbe326",
  null
  
)

export default component.exports